<title>{{ languagesSupportedPage.htmlTitle }}</title>
<app-api-reference-table-section [tableSections]="languagesSupportedPage.tableSections" [languageSupportedPage]="true" [isDefault]="false"></app-api-reference-table-section>
